import { render } from "./pageServices.vue?vue&type=template&id=01194269&scoped=true"
import script from "./pageServices.vue?vue&type=script&lang=js"
export * from "./pageServices.vue?vue&type=script&lang=js"

import "./pageServices.vue?vue&type=style&index=0&id=01194269&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01194269"]])

export default __exports__